import { useGetSiteStatsQuery } from 'src/features/about-us/about-us.slice';
import { TOTAL_USERS } from 'src/common/constants/user';

export const useTotalUsers = () => {
  const { data, isFetching, isLoading, isSuccess } = useGetSiteStatsQuery(null);

  const totalUsers = data?.data?.totalUsers ?? TOTAL_USERS;

  if (isFetching || isLoading) {
    return {
      totalUsers: '0',
    };
  }

  if (isSuccess) {
    return {
      totalUsers: totalUsers.toLocaleString(),
    };
  }

  return {
    totalUsers: TOTAL_USERS.toLocaleString(),
  };
};
